import { Component, Input, OnInit } from '@angular/core';
import { AffiliateBannerConfig } from 'anchor-shared/lib/model/entity/affiliate';
import { AffiliateDAO } from '../../../../../core/services/dao/affiliateDAO';
import { pipe } from 'rxjs/Rx';
import { take } from 'rxjs/operators';
import * as copy from 'copy-to-clipboard';
import { AppMessagingService } from '../../../../../core/services/app-messaging.service';
import { EnvironmentalMediaService } from '../../../../../core/services/environmental-media.service';

@Component({
  selector: 'app-admin-affiliate-info',
  templateUrl: './admin-affiliate-info.component.html',
  styleUrls: ['./admin-affiliate-info.component.scss'],
})
export class AdminAffiliateInfoComponent implements OnInit {
  @Input()
  userId: number;

  affiliateBannerConfig: AffiliateBannerConfig;

  constructor(
    private readonly affiliateDAO: AffiliateDAO,
    private readonly appMessagingService: AppMessagingService,
    private readonly environmentalMediaService: EnvironmentalMediaService,
  ) {}

  ngOnInit(): void {
    this.initAsyncData();
  }

  copyVanity(vanity: string): void {
    const url =
      this.environmentalMediaService.getClientBaseURL() +
      '?affiliate=' +
      vanity;
    this.copyToClipboard(url);
  }

  private copyToClipboard(url: string): void {
    const success = copy(url);
    if (success) {
      this.appMessagingService.openSnack('Copied To Clipboard');
    }
  }

  updateVerifiedBusiness() {
    this.affiliateDAO
      .updateFromPartial(this.affiliateBannerConfig.id, {
        verifiedBusiness: this.affiliateBannerConfig.verifiedBusiness,
      })
      .subscribe(() => {});
  }

  private initAsyncData(): void {
    this.affiliateDAO
      .loadUserForAdmin(this.userId)
      .pipe(take(1))
      .subscribe((bannerConfig) => {
        this.affiliateBannerConfig = bannerConfig;
      });
  }
}
